import { ActionTree, MutationTree, GetterTree, Module } from 'vuex';

import { IColorSettings } from '@/models/interfaces/color-settings';
import { IAchievementData } from '@/models/interfaces/achievements';

import VisualSettings from '@/utils/helpers/VisualSettings';
import StoreUtil from '@/utils/helpers/StoreUtil';
import DataProvider from '@/utils/helpers/DataProvider';

import { RootState } from '..';
import { IVuexState } from '@/models/interfaces/store';
import { IScoresData } from '@/models/interfaces/scores';

const defaultAchievementsSettings = VisualSettings.getDefaultAchievementsSettings();

export interface State {
  achievements: IVuexState<IAchievementData>;
  achievementsSettings: IColorSettings;
  scores: IVuexState<IScoresData>;
}

export const actions: ActionTree<State, RootState> = {
  saveAchievementsSettings({ state }) {
    localStorage.setItem(
      'achievementsSettings',
      JSON.stringify(state.achievementsSettings),
    );
  },
  async fetchAchievements({ commit, rootState }, digiPalId?: string) {
    const {
      session: { userId },
    } = rootState;
    const id = digiPalId || userId;

    commit('setAchievementsData');

    try {
      const response = await DataProvider.get(`users/${id}/achievements`);

      commit('setAchievementsData', response.data);
      return response.data;
    } catch (e) {
      commit('setAchievementsData', e);
      return e;
    }
  },
  async fetchScores({ commit, rootState }, digiPalId?: string) {
    const {
      session: { userId },
    } = rootState;
    const id = digiPalId || userId;

    commit('setAchievementsData');

    try {
      const response = await DataProvider.get(`users/${id}/scores`);

      commit('setAchievementsData', response.data);
      return response.data;
    } catch (e) {
      commit('setAchievementsData', e);
      return e;
    }
  },
};

export const mutations: MutationTree<State> = {
  setAchievementsData(state, data?: IAchievementData | Error) {
    state.achievements = StoreUtil.updateState(state.achievements, data);
  },
  updateAchievementsSettings(state, settings: IColorSettings) {
    state.achievementsSettings = Object.assign(
      state.achievementsSettings,
      settings,
    );
  },
  setScoresData(state, data?: IScoresData | Error) {
    state.scores = StoreUtil.updateState(state.scores, data);
  },
};

export const getters: GetterTree<State, RootState> = {
  getVisualSettings(state) {
    return state.achievementsSettings;
  },
};

const store: Module<State, RootState> = {
  namespaced: true,
  state: {
    achievements: StoreUtil.state<IAchievementData>(),
    achievementsSettings: VisualSettings.getTilesSettingsFromStorage(
      defaultAchievementsSettings,
      'achievementsSettings',
    ),
    scores: StoreUtil.state<IScoresData>(),
  },
  mutations,
  actions,
  getters,
};

export default store;
